module.exports = __webpack_public_path__ + "static/media/igor-anany@2x.1e27586f.png";